import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type GetLatestPhotoCardsResponse =
  paths['/api/v1/photo_cards/latest']['get']['responses'][200]['content']['application/json'];

export type GetLatestPhotoCardsQuery =
  paths['/api/v1/photo_cards/latest']['get']['parameters']['query'];

export async function getLatestPhotoCards({
  query
}: {
  query?: GetLatestPhotoCardsQuery;
}): Promise<GetLatestPhotoCardsResponse> {
  const { data, error } = await client.GET('/api/v1/photo_cards/latest', {
    params: { query },
    headers: authHeaders()
  });

  if (error) throw error;
  if (!data) throw new Error('Empty response when getting latest photo cards');
  return data;
}
